exports.refEquals = function (x) {
  return function (y) {
    return x === y;
  };
};
